// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2fsyg","label":"Category_label__2z8mR","content":"Category_content__2a-1L","header":"Category_header__2GkL6","location":"Category_location__1CrH5"};